import { IconLabel } from "@/core/components/IconLabel";
import type { ReactElement } from "react";
import { Button } from "./ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";

export function LocalRouteErrorScreen({
  missing,
  message,
}: {
  missing: boolean;
  message: string;
}): ReactElement {
  return (
    <main className="grid min-h-dvh place-items-center bg-background p-4 text-foreground">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle role="heading" aria-level={1}>
            <IconLabel icon="warning" size="section">
              {missing ? "Page not found" : "Something went wrong"}
            </IconLabel>
          </CardTitle>
          <CardDescription>
            {missing
              ? "This page may have moved, or the link is incomplete."
              : "Try reloading this page. Your saved bakery data is still available."}
          </CardDescription>
        </CardHeader>
        <CardContent className="grid gap-4">
          {!missing ? (
            <details className="text-sm text-muted-foreground">
              <summary>
                <IconLabel icon="warning">Error details</IconLabel>
              </summary>
              <p className="break-words">{message}</p>
            </details>
          ) : null}
          <div className="flex flex-wrap gap-2">
            <Button asChild>
              <a href="/orders">Back to orders</a>
            </Button>
            {!missing ? (
              <Button
                variant="outline"
                onClick={() => {
                  window.location.reload();
                }}
              >
                Reload page
              </Button>
            ) : null}
          </div>
        </CardContent>
      </Card>
    </main>
  );
}
